import React, {
  createRef, useEffect, useRef, useState,
} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen, faFileArchive } from '@fortawesome/free-solid-svg-icons';
import { ActionsWrapperResultPage } from '../redesignComponents/Purchase/SignatureType.styles';
import uploadIcon from '../../../assets/redesign_icons/upload.svg';
import pdfIMG from '../../../assets/images/purchase/pdf.png';
import downloadIMG from '../../../assets/redesign_icons/download.svg';
import {
  generalAlertError,
} from '../../utils/alerts';
import { sonnerSuccessAlert } from '../../utils/sonnerAlerts';
import {
  apiOptionalDocumentMethodManualUpload,
  documentMethodManualUpload,
} from '../../../services/axios-client/axeCommons';
import { downloadFile } from '../../../services/axios-client/axeHelpers';
import axe from '../../../services/axios-client/axiosClient';
import {
  CompletedCard,
  CompletedCardHeader,
  CompletedCardIcon,
  CompletedCardTitle,
} from '../../../screens/CompletedQuotes/CompletedV2.styles';

function CompletedScreenSanitariaDocuments({
  insuranceRequest, downloadDocument, quote, collectQuoteData, documentsRequests, downloadOptionalDocument, rc_quotation,
}) {
  const uploadPolizzaEmessa = useRef(null); // 13 - Polizza emessa
  const uploadQuietanzaSemestrale = useRef(null); // 32 - Quietanza Semestrale
  const uploadPrivacyRef = useRef(null); // 12 - Privacy Greenia
  const uploadPreContractRef = useRef(null); // 29 - Percontrattuale Greenia
  const uploadDichiarazioniDocRef = useRef(null); // 28 - Dichiarazioni del contraente
  const uploadQuestionarioAutoDocRef = useRef(null); // 30 - Questionario Auto
  const uploadMergedDocFileRef = useRef(null); // 34 - Questionario Auto
  const [optionalRefs, setOptionalRefs] = useState({});

  const fireSignedDocUpload = (typeId, docId) => {
    if ([13, 35].includes(typeId)) {
      uploadPolizzaEmessa.current.click();
    }
    if (typeId === 32) {
      uploadQuietanzaSemestrale.current.click();
    }
    if (typeId === 29) {
      uploadPreContractRef.current.click();
    }

    if (typeId === 12) {
      uploadPrivacyRef.current.click();
    }

    if (typeId === 26) {
      optionalRefs[docId].current.click();
    }

    if (typeId === 28) {
      uploadDichiarazioniDocRef.current.click();
    }

    if (typeId === 30) {
      uploadQuestionarioAutoDocRef.current.click();
    }

    if (typeId === 34) {
      uploadMergedDocFileRef.current.click();
    }
  };

  const uploadSignedOptionalDocument = async (documentId, file) => {
    const uploadedFile = file[0];
    const reader = new FileReader();
    reader.readAsDataURL(uploadedFile);
    if (uploadedFile.type !== 'application/pdf') {
      generalAlertError('Formato di file errato. Il file deve essere in .pdf');
      return;
    }
    reader.onload = () => {
      apiOptionalDocumentMethodManualUpload(quote.id, documentId, {
        document: reader.result.replace('data:application/pdf;base64,', ''),
      }).then(() => {
        collectQuoteData();
        sonnerSuccessAlert('File caricato');
      });
    };
  };

  const uploadSignedDocument = async (documentId, files) => {
    const uploadedFile = files[0];
    const reader = new FileReader();

    reader.readAsDataURL(uploadedFile);
    if (uploadedFile.type !== 'application/pdf') {
      generalAlertError('Formato di file errato. Il file deve essere in .pdf');
      return;
    }
    reader.onload = () => {
      documentMethodManualUpload(quote.id, documentId, {
        document: reader.result.replace('data:application/pdf;base64,', ''),
      }).then(() => {
        collectQuoteData();
        sonnerSuccessAlert('File caricato');
      });
    };
  };

  let initialQuotationDocumentRequests = [];

  if (quote.initial_quotation !== undefined) {
    initialQuotationDocumentRequests = [
      ...quote.initial_quotation.insurance_request.document_requests.filter(
        (dr) => dr.document !== null,
      ),
      ...quote.initial_quotation.document_requests.filter(
        (dr) => dr.document !== null,
      ),
    ];
  }

  const downloadInvoice = async (quoteId, payment_number) => {
    const res = await axe.get(`/list/invoices/${quoteId}/download/${payment_number}`, {
      responseType: 'blob',
    });
    const contentDisposition = res.headers['content-disposition'];
    const file_name = contentDisposition.split('filename="')[1].split('"')[0];
    downloadFile(res.data, file_name);
  };

  useEffect(() => {
    const optionalDocs = {};
    documentsRequests
      .filter((d) => d.optional_document_request_id !== undefined)
      .forEach((doc) => {
        optionalDocs[doc.id] = createRef(null);
      });

    setOptionalRefs(optionalDocs);
  }, [JSON.stringify(documentsRequests)]);
  return (
    <>
      <div className="col-12 mt-4">
        <CompletedCard className="mb-3 polizze-emessa-status-step-four">
          <CompletedCardHeader>
            <CompletedCardIcon>
              <FontAwesomeIcon icon={faFolderOpen} />
            </CompletedCardIcon>
            <CompletedCardTitle>Documenti</CompletedCardTitle>
          </CompletedCardHeader>
          <div className="documents-body">
            <ul className="documents-list">
              {insuranceRequest.documents.filter((dr) => (dr.document_type_id !== 32 && dr.document_type_id !== 34 && dr.document_type_id !== 35 && dr.document_type_id !== 36 && dr.document_type_id !== 37 && dr.document_type_id !== 38 && dr.document_type_id !== 39 && dr.document_type_id !== 40 && dr.document_type_id !== 41)).map((document, index) => (
                <li
                  className="document-item"
                  key={index}
                >
                  <div className="document-content flex-column">
                    <div className="document-name">
                      {document.document_type_id === 13
                        && insuranceRequest.quotation_renewal_request !== null
                        ? 'Rinnovo'
                        : document.document_type.name}
                    </div>
                    <div className="document-actions flex-row">
                      <div className="file-info">
                        <img
                          src={pdfIMG}
                          className="img-fluid"
                          width="25"
                          alt="PDF"
                        />
                        <span className="file-name">
                          {document.original_filename}
                        </span>
                      </div>
                      <button
                        className="doc-btn border-0 bg-transparent"
                        onClick={() => downloadDocument(document.id)}
                      >
                        <img src={downloadIMG} width="25" alt="Scarica" />
                      </button>
                      {document.signable_document === 1
                        && (document.is_signed_valid === 0
                          || (document.is_signed_valid === null
                            && document.signed_document_filename === null)) && (
                            <ActionsWrapperResultPage>
                              {' '}
                              {([13, 35].includes(document.document_type.id)) && (
                              <div
                                className="action-button"
                                onClick={() => fireSignedDocUpload(document.document_type_id)}
                              >
                                <img src={uploadIcon} alt="" width={25} />
                                <input
                                  ref={uploadPolizzaEmessa}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {document.document_type.id === 32 && (
                              <div
                                className="action-button"
                                onClick={() => fireSignedDocUpload(document.document_type_id)}
                              >
                                <img src={uploadIcon} alt="" width={25} />
                                <input
                                  ref={uploadQuietanzaSemestrale}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {document.document_type.id === 29 && (
                              <div
                                className="action-button"
                                onClick={
                                  document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      document.document_type.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={uploadPreContractRef}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {document.document_type.id === 28 && (
                              <div
                                className="action-button"
                                onClick={
                                  document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      document.document_type.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={uploadDichiarazioniDocRef}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {document.document_type.id === 30 && (
                              <div
                                className="action-button"
                                onClick={
                                  document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      document.document_type.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={uploadQuestionarioAutoDocRef}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {document.document_type.id === 34 && (
                              <div
                                className="action-button"
                                onClick={
                                  document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      document.document_type.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={uploadMergedDocFileRef}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {document.optional_document_request_id && (
                              <div
                                className="action-button"
                                onClick={
                                  document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      document.document_type.id,
                                      document.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={optionalRefs[document.id]}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedOptionalDocument(
                                    document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {document.document_type.id === 12 && (
                              <div
                                className="action-button"
                                onClick={
                                  document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      document.document_type.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={uploadPrivacyRef}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                            </ActionsWrapperResultPage>
                      )}
                    </div>
                    {document.signable_document === 1
                      && document.is_signed_valid === 0
                      && document.signed_document_filename === null
                      && document.motivation !== null && (
                        <p className="document-motivation">
                          {document.motivation}
                        </p>
                    )}
                  </div>
                  <div className="document-status">
                    {document.signable_document === 1 ? (
                      document.is_signed_valid === null
                        && document.signed_document_filename !== null ? (
                          <span className="status-badge status-warning">
                            In Verifica
                          </span>
                        ) : document.is_signed_valid === 0 ? (
                          <span className="status-badge status-danger">
                            Firma Non Valida
                          </span>
                        ) : document.is_signed_valid === null
                        && document.signed_document_filename === null ? (
                          <span className="status-badge status-warning">
                            Da Firmare
                          </span>
                          ) : document.is_signed_valid === 1
                        && document.signed_document_filename !== null ? (
                          <span className="status-badge status-success">
                            Firmato
                          </span>
                            ) : null
                    ) : (
                      <span className="status-badge status-info">
                        Non Richiede Firma
                      </span>
                    )}
                  </div>
                </li>
              ))}
              {rc_quotation.documents.map((document, index) => (
                <li
                  className="document-item"
                  key={index}
                >
                  <div className="document-content flex-column">
                    <div className="document-name">
                      {document.document_type.name}
                    </div>
                    <div className="document-actions flex-row">
                      <div className="file-info">
                        <img
                          src={pdfIMG}
                          className="img-fluid"
                          width="25"
                          alt="PDF"
                        />
                        <span className="file-name">
                          {document.original_filename}
                        </span>
                      </div>
                      <button
                        className="doc-btn border-0 bg-transparent"
                        onClick={() => downloadDocument(document.id)}
                      >
                        <img src={downloadIMG} width="25" alt="Scarica" />
                      </button>
                      {document.signable_document === 1
                        && (document.is_signed_valid === 0
                          || (document.is_signed_valid === null
                            && document.signed_document_filename === null)) && (
                            <ActionsWrapperResultPage>
                              {' '}
                              {document.document_type.id === 13 && (
                              <div
                                className="action-button"
                                onClick={() => fireSignedDocUpload(document.document_type_id)}
                              >
                                <img src={uploadIcon} alt="" width={25} />
                                <input
                                  ref={uploadPolizzaEmessa}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {document.document_type.id === 32 && (
                              <div
                                className="action-button"
                                onClick={() => fireSignedDocUpload(document.document_type_id)}
                              >
                                <img src={uploadIcon} alt="" width={25} />
                                <input
                                  ref={uploadQuietanzaSemestrale}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {document.document_type.id === 29 && (
                              <div
                                className="action-button"
                                onClick={
                                  document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      document.document_type.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={uploadPreContractRef}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {document.document_type.id === 28 && (
                              <div
                                className="action-button"
                                onClick={
                                  document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      document.document_type.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={uploadDichiarazioniDocRef}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {document.document_type.id === 30 && (
                              <div
                                className="action-button"
                                onClick={
                                  document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      document.document_type.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={uploadQuestionarioAutoDocRef}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {document.optional_document_request_id && (
                              <div
                                className="action-button"
                                onClick={
                                  document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      document.document_type.id,
                                      document.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={optionalRefs[document.id]}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedOptionalDocument(
                                    document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {document.document_type.id === 12 && (
                              <div
                                className="action-button"
                                onClick={
                                  document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      document.document_type.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={uploadPrivacyRef}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                            </ActionsWrapperResultPage>
                      )}
                    </div>
                    {document.signable_document === 1
                      && document.is_signed_valid === 0
                      && document.signed_document_filename === null
                      && document.motivation !== null && (
                        <p className="document-motivation">
                          {document.motivation}
                        </p>
                    )}
                  </div>
                  <div className="document-status">
                    {document.signable_document === 1 ? (
                      document.is_signed_valid === null
                        && document.signed_document_filename !== null ? (
                          <span className="status-badge status-warning">
                            In Verifica
                          </span>
                        ) : document.is_signed_valid === 0 ? (
                          <span className="status-badge status-danger">
                            Firma Non Valida
                          </span>
                        ) : document.is_signed_valid === null
                        && document.signed_document_filename === null ? (
                          <span className="status-badge status-warning">
                            Da Firmare
                          </span>
                          ) : document.is_signed_valid === 1
                        && document.signed_document_filename !== null ? (
                          <span className="status-badge status-success">
                            Firmato
                          </span>
                            ) : null
                    ) : (
                      <span className="status-badge status-info">
                        Non Richiede Firma
                      </span>
                    )}
                  </div>
                </li>
              ))}

              {documentsRequests.map((dr, index) => (
                <li
                  className="document-item"
                  key={index}
                >
                  <div className="document-content flex-column">
                    <div className="document-name">
                      {dr.optional_document_type.name}
                    </div>
                    <div className="document-actions flex-row">
                      <div className="file-info">
                        <img
                          src={pdfIMG}
                          className="img-fluid"
                          width="25"
                          alt="PDF"
                        />
                        <span className="file-name">
                          {dr.document.original_filename}
                        </span>
                      </div>
                      <button
                        className="doc-btn border-0 bg-transparent"
                        onClick={() => downloadOptionalDocument(dr.document.id)}
                      >
                        <img src={downloadIMG} width="25" alt="Scarica" />
                      </button>
                      {dr.document.signable_document === 1
                        && (dr.document.is_signed_valid === 0
                          || (dr.document.is_signed_valid === null
                            && dr.document.signed_document_filename === null)) && (
                            <ActionsWrapperResultPage>
                              {' '}
                              {dr.document.document_type && dr.document.document_type.id === 13 && (
                              <div
                                className="action-button"
                                onClick={() => fireSignedDocUpload(dr.document.document_type_id)}
                              >
                                <img src={uploadIcon} alt="" width={25} />
                                <input
                                  ref={uploadPolizzaEmessa}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    dr.document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {dr.document.document_type && dr.document.document_type.id === 32 && (
                              <div
                                className="action-button"
                                onClick={() => fireSignedDocUpload(dr.document.document_type_id)}
                              >
                                <img src={uploadIcon} alt="" width={25} />
                                <input
                                  ref={uploadQuietanzaSemestrale}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    dr.document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {dr.document.document_type && dr.document.document_type.id === 29 && (
                              <div
                                className="action-button"
                                onClick={
                                  dr.document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      dr.document.document_type.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={uploadPreContractRef}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    dr.document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {dr.document.document_type && dr.document.document_type.id === 28 && (
                              <div
                                className="action-button"
                                onClick={
                                  dr.document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      dr.document.document_type.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={uploadDichiarazioniDocRef}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    dr.document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {dr.document.document_type && dr.document.document_type.id === 30 && (
                              <div
                                className="action-button"
                                onClick={
                                  dr.document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      dr.document.document_type.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={uploadQuestionarioAutoDocRef}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    dr.document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {dr.document.optional_document_request_id && (
                              <div
                                className="action-button"
                                onClick={
                                  dr.document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      dr.document.document_type && dr.document.document_type.id,
                                      dr.document.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={optionalRefs[dr.document.id]}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedOptionalDocument(
                                    dr.document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                              {dr.document.document_type && dr.document.document_type.id === 12 && (
                              <div
                                className="action-button"
                                onClick={
                                  dr.document.signed_document_filename === null
                                    ? () => fireSignedDocUpload(
                                      dr.document.document_type.id,
                                    )
                                    : () => { }
                                }
                              >
                                <img src={uploadIcon} alt="Carica" width={25} />
                                <input
                                  ref={uploadPrivacyRef}
                                  type="file"
                                  name=""
                                  id=""
                                  className="d-none"
                                  onChange={(e) => uploadSignedDocument(
                                    dr.document.id,
                                    e.target.files,
                                  )}
                                />
                              </div>
                              )}
                            </ActionsWrapperResultPage>
                      )}
                    </div>
                    {dr.document.signable_document === 1
                      && dr.document.is_signed_valid === 0
                      && dr.document.signed_document_filename === null
                      && dr.document.motivation !== null && (
                        <p className="document-motivation">
                          {dr.document.motivation}
                        </p>
                    )}
                  </div>
                  <div className="document-status">
                    {dr.document.signable_document === 1 ? (
                      dr.document.is_signed_valid === null
                        && dr.document.signed_document_filename !== null ? (
                          <span className="status-badge status-warning">
                            In Verifica
                          </span>
                        ) : dr.document.is_signed_valid === 0 ? (
                          <span className="status-badge status-danger">
                            Firma Non Valida
                          </span>
                        ) : dr.document.is_signed_valid === null
                        && dr.document.signed_document_filename === null ? (
                          <span className="status-badge status-warning">
                            Da Firmare
                          </span>
                          ) : dr.document.is_signed_valid === 1
                        && dr.document.signed_document_filename !== null ? (
                          <span className="status-badge status-success">
                            Firmato
                          </span>
                            ) : null
                    ) : (
                      <span className="status-badge status-info">
                        Non Richiede Firma
                      </span>
                    )}
                  </div>
                </li>
              ))}
              {quote.payments.length > 0 && quote.payments.map((payment, paymentIndex) => (
                <li className="document-item" key={`invoice-${paymentIndex}`}>
                  <div className="document-content flex-column">
                    <div className="document-name">
                      {quote.payments.length > 1
                        ? `Fattura ${paymentIndex + 1}`
                        : 'Fattura'}
                    </div>
                    <div className="document-actions flex-row">
                      <div className="file-info">
                        <img src={pdfIMG} className="img-fluid" width="25" alt="PDF" />
                        <span className="file-name">Scarica Fattura</span>
                      </div>
                      <button
                        className="doc-btn border-0 bg-transparent"
                        onClick={() => downloadInvoice(quote.id, paymentIndex + 1)}
                      >
                        <img src={downloadIMG} width="25" alt="Scarica" />
                      </button>
                    </div>
                  </div>
                  <div className="document-status">
                    <span className="status-badge status-info">Non Richiede Firma</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </CompletedCard>
      </div>
      {rc_quotation.initial_quotation !== undefined && (
        <div className="col-12 mt-4">
          <CompletedCard className="">
            <CompletedCardHeader>
              <CompletedCardIcon>
                <FontAwesomeIcon icon={faFileArchive} />
              </CompletedCardIcon>
              <CompletedCardTitle>
                Documenti nel preventivo iniziale
              </CompletedCardTitle>
            </CompletedCardHeader>
            <div className="documents-body">
              <ul className="documents-list">
                {rc_quotation.initial_quotation.insurance_request.documents.map(
                  (document, index) => (
                    <li
                      className="document-item"
                      key={index}
                    >
                      <div className="document-content flex-column">
                        <div className="document-name">
                          {document.document_type.name}
                        </div>
                        <div className="document-actions flex-row">
                          <div className="file-info">
                            <img
                              src={pdfIMG}
                              className="img-fluid"
                              width="25"
                              alt="PDF"
                            />
                            <span className="file-name">
                              {document.original_filename}
                            </span>
                          </div>
                          <button
                            className="doc-btn border-0 bg-transparent"
                            onClick={() => downloadDocument(document.id)}
                          >
                            <img src={downloadIMG} width="25" alt="Scarica" />
                          </button>
                        </div>
                      </div>
                      <div className="document-status">
                        {document.signable_document === 1
                          && document.is_signed_valid ? (
                            <span className="status-badge status-success">
                              Firmato
                            </span>
                          ) : (
                            <span className="status-badge status-info">
                              Non Richiede Firma
                            </span>
                          )}
                      </div>
                    </li>
                  ),
                )}
                {rc_quotation.initial_quotation.documents.map((document, index) => (
                  <li
                    className="document-item"
                    key={index}
                  >
                    <div className="document-content flex-column">
                      <div className="document-name">
                        {document.document_type.name}
                      </div>
                      <div className="document-actions flex-row">
                        <div className="file-info">
                          <img
                            src={pdfIMG}
                            className="img-fluid"
                            width="25"
                            alt="PDF"
                          />
                          <span className="file-name">
                            {document.original_filename}
                          </span>
                        </div>
                        <button
                          className="doc-btn border-0 bg-transparent"
                          onClick={() => downloadDocument(document.id)}
                        >
                          <img src={downloadIMG} width="25" alt="Scarica" />
                        </button>
                      </div>
                    </div>
                    <div className="document-status">
                      {document.signable_document === 1
                        && document.is_signed_valid ? (
                          <span className="status-badge status-success">
                            Firmato
                          </span>
                        ) : (
                          <span className="status-badge status-info">
                            Non Richiede Firma
                          </span>
                        )}
                    </div>
                  </li>
                ))}

                {initialQuotationDocumentRequests.map((dr, index) => (
                  <li
                    className="document-item"
                    key={index}
                  >
                    <div className="document-content flex-column">
                      <div className="document-name">
                        {dr.optional_document_type.name}
                      </div>
                      <div className="document-actions flex-row">
                        <div className="file-info">
                          <img
                            src={pdfIMG}
                            className="img-fluid"
                            width="25"
                            alt="PDF"
                          />
                          <span className="file-name">
                            {dr.document.original_filename}
                          </span>
                        </div>
                        <button
                          className="doc-btn border-0 bg-transparent"
                          onClick={() => downloadOptionalDocument(dr.document.id)}
                        >
                          <img src={downloadIMG} width="25" alt="Scarica" />
                        </button>
                      </div>
                    </div>
                    <div className="document-status">
                      {dr.document.signable_document === 1
                        && dr.document.is_signed_valid ? (
                          <span className="status-badge status-success">
                            Firmato
                          </span>
                        ) : (
                          <span className="status-badge status-info">
                            Non Richiede Firma
                          </span>
                        )}
                    </div>
                  </li>
                ))}

              </ul>
            </div>
          </CompletedCard>
        </div>
      )}
    </>
  );
}

export default CompletedScreenSanitariaDocuments;
